import React from "react";
import { SXBackground } from "./SXBackground";
import { Col, Container, Nav, Navbar, Row } from "react-bootstrap";
import LoginButton from "./LoginButton";
import { useTranslation } from "react-i18next";

export function SXLoadingMessages(props: { errorMsg: string; useauth0: any }) {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading, logout, loginWithRedirect } = props.useauth0();
  const msg = props.errorMsg?.trim() ?? "";
  const loadingTitle = t("loading_app_.label", "Loading");
  const errorTitle = t("loading_app_error_.label", "Something went wrong");

  const msgNormalized = msg.toLowerCase();
  const hasExplicitErrorMessage =
    msgNormalized.includes("loading_app_error_") ||
    msgNormalized.includes("loading_error_") ||
    msgNormalized.includes("error");
  const isGenericLoadingMessage =
    msg.length === 0 ||
    msg === "Loading..." ||
    msg === loadingTitle ||
    msg === "loading_.label" ||
    msg === "loading_app_.label";

  // Error state must take precedence over any transient loading flag.
  const hasError = hasExplicitErrorMessage || (!isLoading && !isGenericLoadingMessage);

  const title = hasError ? errorTitle : loadingTitle;

  const bodyText =
    msgNormalized === "loading_error_.label" || msgNormalized === "loading_app_error_.label"
      ? errorTitle
      : isGenericLoadingMessage
        ? t("loading_app_please_wait_.label", "Please wait while we prepare the app.")
        : msg.length > 0
          ? msg
          : t("loading_app_please_wait_.label", "Please wait while we prepare the app.");

  const showLoginAction = hasError || !isAuthenticated;

  return (
    <>
      <Container fluid id="app_container">
        {/* Top Navigation Bar */}
        <Navbar id="top-nav-bar" className="top-nav-bar-bg">
          <Nav className="me-auto"></Nav>
          <Nav></Nav>
          <Nav></Nav>
          <Nav>
            <Nav.Link className="nav-link"></Nav.Link>
          </Nav>
          <Nav></Nav>
        </Navbar>
        {/* This is the offcanvas menu that will be shown when the user clicks on UserInitialsIcon */}
        {/* Main Application Row */}

        <Row id="main-app-row" style={{ height: "100%", position: "relative", zIndex: 10 }}>
          <SXBackground />
          <Col id="main-app-col" className="d-flex flex-column align-items-center justify-content-center">
            <div
              id="overlay-spinner"
              style={{
                background: `rgba(0, 0, 0, ${false ? 0.5 : 0.5})`,
                top: `${false ? 0 : 50}`,
                overflowY: false ? "scroll" : "hidden",
              }}
            >
              <div className="overlay_inner">
                <div className={`overlay_panel ${hasError ? "overlay_panel_error" : ""}`}>
                  <div className="overlay_indicator">
                    {hasError ? <span className="overlay_error_icon">!</span> : <span className="spinner" />}
                  </div>

                  <div className="overlay_message_box">
                    <h4 className="overlay_title">{title}</h4>
                    <p className="overlay_message_text">{bodyText}</p>
                  </div>

                  {showLoginAction && (
                    <div className="overlay_actions">
                      <LoginButton
                        flat={false}
                        className="overlay_login-btn"
                        isAuthenticated={isAuthenticated}
                        isLoading={isLoading}
                        loginWithRedirect={loginWithRedirect}
                        logout={logout}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
